import AgoraRTC, {
    LocalUser,
    RemoteUser,
    useIsConnected,
    useJoin,
    useLocalMicrophoneTrack,
    useLocalCameraTrack,
    usePublish,
    useRemoteUsers,
    useLocalScreenTrack,
    LocalVideoTrack
} from "agora-rtc-react";
import { ArrowUp, Book, Book1, CallRemove, DocumentDownload, Edit, Eye, Messages, Microphone, MicrophoneSlash, More, Profile, Profile2User, Screenmirroring, SearchNormal1, Send, Send2, Sms, UserAdd, UserCirlceAdd, Video, VideoSlash } from "iconsax-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { X } from "lucide-react";
import { useLoaderData, useLocation, useNavigate } from "react-router-dom";
import instance, { url } from "../../../../axios/instance";
import { toast } from "react-toastify";
import { SocketContext } from "../context/SocketContext";
import formatTimestamp from "../utils/format_timestamp";
import { getToken } from "../../../../utils/token";
import { generateInstantChannel } from "../children/dashboard/page";
import Draggable from "react-draggable";
import useConferenceDuration from "../hooks/useConferenceDuration";


export default function InstantMeetingRoom({ token, meetingData }) {

    const [loading, setLoading] = useState(false)
    const [screenShareOn, setScreenShareOn] = useState(false)
    const [viewParticipants, setViewParticipants] = useState(false)
    const [viewInviteLink, setViewInviteLink] = useState(false)
    const [isChatOpen, setIsChatOpen] = useState(false)

    const user = useLoaderData()

    const navigate = useNavigate()

    console.log("Meeting screen", meetingData);
    
    const [micOn, setMic] = useState(false);
    const [cameraOn, setCamera] = useState(false);
    const { localMicrophoneTrack } = useLocalMicrophoneTrack(micOn, {
        AEC: true, // Acoustic Echo Cancellation
        ANS: true, // Automatic Noise Suppression
        AGC: true, // Automatic Gain Control
    });
    const { localCameraTrack } = useLocalCameraTrack(cameraOn);
    const [calling, setCalling] = useState(true)
    const { screenTrack, error } = useLocalScreenTrack(screenShareOn, {}, "disable");
    usePublish([localMicrophoneTrack, localCameraTrack, screenTrack]);

    const inviteLink = `${url}/telemedicine/meeting/invite/instant/${meetingData.doctor_id}` // change this

    // production url: https://nova.careapps.net/telemedicine/meeting/invite/guest/${meetingData.meeting.id}

    const remoteUsers = useRemoteUsers();

    // trigger message notif
    const [messageNotif, setMessageNotif] =  useState(false)

    // this is the main one
    useJoin(
        {
            uid: meetingData.doctor_id,
            appid: "df936d67e3aa4a44829bb8ecff6e33bc", 
            channel: generateInstantChannel(meetingData.doctor_id), 
            token: token
        }, 
        calling
    );

    const duration = useConferenceDuration(calling)
    

    function handleChatDisplay() {
        setMessageNotif(false)
        setIsChatOpen(!isChatOpen)
    }

    async function handleEndMeeting() {
        setCalling(false)
        navigate("/dashboard/telemedicine")
    }

    // audio logic start
    const [micInstance, setMicInstance] = useState(false) // mic is off my default
    // Mute local audio
    const muteLocalAudio = (audioTrack) => {
        if (!audioTrack) return;
        audioTrack.setVolume(0);
    };
    
    // Unmute local audio
    const unmuteLocalAudio = (audioTrack) => {
        if (!audioTrack) return;
        audioTrack.setVolume(100);  // Set the volume to a reasonable volume level
    };
    // audio logic end

    // vidio logic start
    const [videoInstance, setVideoInstance] = useState(false) // video is off my default
    const turnOffLocalVideo = (videoTrack) => {
        if (!videoTrack) return;
        videoTrack.setEnabled(false);
    };
    
    // Unmute local video
    const turnOnLocalVideoo = (videoTrack) => {
        if (!videoTrack) return;
        videoTrack.setEnabled(true);
    };
    // video logic end


    // screen share logic
    const [screenShareTrack, setScreenShareTrack] = useState(null)
    function tesFunc() {
        const screenShareTrack = AgoraRTC.createScreenVideoTrack()
    }


    function handleScreenSharing() {
        console.log("share screen");
        if (screenShareOn) {
            setScreenShareOn(false)
        } else {
            setScreenShareOn(true)
        }
    }

    

    

 
    if (loading) {
        return <div>loading call</div>
    }

    return (
        <div className="bg-[#20232b] h-[100svh]"> 
            <div className="py-3 px-5 h-[10%] lg:hidden gap-3 flex items-center justify-between bg-[#20232b]">
                <div>
                    <div className="text-gray-300 text-[10px] mb-[2px]">{meetingFormatDate()}</div>
                    <div className="text-[#fafafa] text-[12px] font-medium">Instant Meeting - {meetingData.doctor_id}</div>
                </div>

                <div className="text-[#fafafa] font-medium text-[12px]">{formatDuration(duration)}</div>
            </div>
            <div className="bg-[#20232b] h-[80%] lg:h-[90%]">
                {/* we will render UI with certain conditions */}

                {/* Condition 1 - if sharing screen is active */}
                {
                    screenShareOn ? 
                    <div className="grid grid-cols-12 w-full h-full">
                        <div className="col-span-9 p-4">
                            <div className="w-full h-full bg-black">
                                <LocalVideoTrack track={screenTrack} play style={{ width: "100%", height: "100%" }} />
                            </div>
                        </div>

                        <div className="col-span-3 overflow-y-scroll border-l max-h-[100%] bg-white">
                            <div className="sticky top-0 left-0 right-0 bg-white px-3 py-3">
                                <div className="font-medium">Meeting Participants ({remoteUsers.length + 1})</div>
                            </div>

                            <div className="px-4 py-3 space-y-3">
                                
                                {/* local user cam */}
                                <div className="w-full h-[200px] z-[100]">
                                    {
                                        !videoInstance || !cameraOn ? <LocalUserCameraOff /> :
                                        <LocalUser 
                                            cameraOn={cameraOn}
                                            micOn={micOn}
                                            videoTrack={localCameraTrack}
                                        />
                                    }
                                    
                                </div>
                                {/* local user cam */}
                                {
                                    remoteUsers.map(user => (
                                        <div key={user.uid} className="w-full h-[200px]">
                                            <RemoteUser user={user} />
                                        </div>
                                    ))
                                }

                                {/* <div className="w-full rounded-[6px] h-[200px] z-[100] bg-black"></div>
                                <div className="w-full rounded-[6px] h-[200px] z-[100] bg-black"></div>
                                <div className="w-full rounded-[6px] h-[200px] z-[100] bg-black"></div> */}
                            </div>
                        </div>
                    </div> : 
                    // condition 1.5 - if there is only 1 person in the meeting
                    remoteUsers.length < 1 ?
                    <div className="w-full h-full flex justify-center items-center relative">
                        <div className="lg:w-[80%] lg:h-[90%] w-[90%] h-[50%] rounded-[10px] overflow-hidden">
                            {
                                // !cameraOn || !videoInstance ? <LocalUserCameraOff /> :
                                <LocalUser 
                                    cameraOn={cameraOn}
                                    micOn={micOn}
                                    videoTrack={localCameraTrack}
                                >
                                    <div className={`w-full h-full p-4 text-gray-100 text-[13px] flex justify-start items-end`}>{user.prefix} {user.firstname} {user.lastname} (You)</div>
                                </LocalUser>
                            }
                        </div>
                    </div> :
                    /* Condition 2 - if there are only 2 participants */
                    remoteUsers.length < 2 ? 
                    <div className="w-full h-full relative flex flex-col lg:flex-row-reverse lg:px-10 items-center gap-4 lg:gap-8 justify-center">
                        <Draggable>
                            <div className="lg:w-[300px] lg:h-[200px] w-[90%] h-[50%] rounded-[8px] overflow-hidden z-[100]">
                                {
                                    // !cameraOn || !videoInstance ? <LocalUserCameraOff /> :
                                    <LocalUser 
                                        cameraOn={cameraOn}
                                        micOn={micOn}
                                        videoTrack={localCameraTrack}
                                        
                                    >
                                        <div className={`w-full h-full p-4 text-gray-100 text-[13px] flex justify-start items-end`}>{user.prefix} {user.firstname} {user.lastname} (You)</div>
                                    </LocalUser>
                                }
                            </div>
                        </Draggable>

                        <div className="lg:w-[80%] lg:h-[90%] w-[90%] h-[50%] rounded-[10px] overflow-hidden">    
                            <RemoteUser user={remoteUsers[0]}>
                                <div className={`w-full h-full p-4 text-gray-100 text-[13px] flex justify-start items-end`}>{remoteUsers[0].uid}</div>
                            </RemoteUser>
                        </div>
                    </div> : 
                    /* Condition 3 - if there are more than 2 participants */
                    <div className="w-full h-full flex flex-wrap gap-3 overflow-y-scroll justify-center items-center lg:p-4">
                        {/* local user cam */}
                        <div className="col-span-6 rounded-[10px] overflow-hidden min-w-[90%] lg:min-w-[40%] h-[50%] z-[100]">
                            {
                                // !cameraOn || !videoInstance ? <LocalUserCameraOff /> :
                                <LocalUser 
                                    cameraOn={cameraOn}
                                    micOn={micOn}
                                    videoTrack={localCameraTrack}
                                >
                                    <div className={`w-full h-full p-4 text-gray-100 text-[13px] flex justify-start items-end`}>{user.prefix} {user.firstname} {user.lastname} (You)</div>
                                </LocalUser>
                            }
                            
                        </div>
                        {/* local user cam */}
                        {
                            remoteUsers.map(user => (
                                <div key={user.uid} className="col-span-6 rounded-[10px] overflow-hidden max-w-[90%] lg:max-w-[40%] min-w-[90%] lg:min-w-[40%] flex-1  h-[50%]">
                                    <RemoteUser user={user}>
                                        <div className="w-full h-full p-4 text-gray-100 text-[13px] flex justify-start items-end">{user.uid}</div>
                                    </RemoteUser>
                                </div>
                            ))
                        }

                        

                    </div>
                }
            </div>
            
            <div className="py-3 px-5 h-[10%] gap-3 flex items-center justify-center lg:justify-between bg-[#20232b]">
                <div className="lg:block hidden">
                    <div className="text-gray-300 text-[10px] mb-[2px]">{meetingFormatDate()}</div>
                    <div className="text-[#fafafa] text-[12px] font-medium">Instant Meeting - {meetingData.doctor_id}</div>
                </div>
               
                <div className="flex justify-center items-center gap-3">
                    <button onClick={() => {
                        if (micInstance) {
                            setMicInstance(false)
                            setMic(false)
                            muteLocalAudio(localMicrophoneTrack)
                        } else {
                            setMicInstance(true)
                            setMic(true)
                            unmuteLocalAudio(localMicrophoneTrack)
                        }
                    }} className="w-10 h-10 rounded-full bg-[#00b0ad21] flex justify-center items-center">
                        {
                            !micInstance || !micOn ?
                            <MicrophoneSlash size={20} color="#00b0ad" variant="Bold"  /> :
                            <Microphone size={20} color="#00b0ad" variant="Bold"  />
                        }  
                    </button>

                    <button onClick={() => {
                        if (videoInstance) {
                            setVideoInstance(false)
                            setCamera(false)
                            turnOffLocalVideo(localCameraTrack)
                        } else {
                            setVideoInstance(true)
                            setCamera(true)
                            turnOnLocalVideoo(localCameraTrack)
                        }
                    }} className="w-10 h-10 rounded-full bg-[#00b0ad21] flex justify-center items-center">
                        {
                            !videoInstance || !cameraOn ?
                            <VideoSlash size={20} color="#00b0ad" variant="Bold"  /> :
                            <Video size={20} color="#00b0ad" variant="Bold"  />
                        }      
                    </button>

                    <button onClick={handleScreenSharing} className="w-10 h-10 rounded-full bg-[#00b0ad21] flex justify-center items-center">
                        <ArrowUp size={20} width="20px" height="20px" color="#00b0ad" variant="Bold"  />
                    </button>

                    <button onClick={handleChatDisplay} className={`w-10 h-10 relative rounded-full ${!isChatOpen ? "bg-[#00b0ad21]" : "bg-[#00b0ad]"} flex justify-center items-center`}>
                        <Messages size={20} color={!isChatOpen ? "#00b0ad" : "#fff"} variant="Bold"  />
                        {
                            messageNotif ? 
                            <div className="bg-red-500 w-3 h-3 top-0 right-0 absolute z-[1000] rounded-full"></div> : null
                        }
                    </button>


                    <div className="relative">
                        <ParticipantList currentUser={`${user.prefix} ${user.firstname} ${user.lastname}`} participants={remoteUsers} isModalOpen={viewParticipants} onModalClose={() => setViewParticipants(false)} />
                        <button onClick={() => setViewParticipants(!viewParticipants)} className={`w-10 h-10 rounded-full ${!viewParticipants ? "bg-[#00b0ad21]" : "bg-[#00b0ad]"} flex justify-center items-center`}>
                            <Profile2User size={20}  color={!viewParticipants ? "#00b0ad" : "#fff"} variant="Bold"  />
                        </button>
                    </div>


                    <button onClick={handleEndMeeting} className="w-10 h-10 rounded-full bg-red-500 flex justify-center items-center">
                        <CallRemove size={20} color="#fff" variant="Bold"  />
                    </button>
                </div>

                <div className="text-[#fafafa] font-medium text-[12px] lg:block hidden">{formatDuration(duration)}</div>
            </div>
          


            <MeetingChat 
                roomID={generateInstantChannel(meetingData.doctor_id)}
                isChatOpen={isChatOpen} 
                onChatClose={() => setIsChatOpen(false)}
                // participantName={meetingData.meeting.doctor_name} // get doctor name from you know
                messageNotif={data => {
                    if (data) {
                        setMessageNotif(true)
                    }
                }}
            /> 
        </div>
    )
}



export function MeetingChat({ isChatOpen, onChatClose, participantName, roomID, messageNotif }) {


    const [message, setMessage] = useState("")
    const socket = useContext(SocketContext)
    const [messages, setMessages] = useState([])
    const messageRef = useRef()

    const user = useLoaderData()


    function sendMessage() {
        if (!message) {
            toast.error("Input field cannot be empty", {
                position: "bottom-right"
            })
        } else {

            const messageData = {
                user: `${user.prefix}. ${user.firstname} ${user.lastname}`,
                roomID: roomID,
                message: message,
                createdAt: Date.now()
            }

            socket.emit("send_meeting_message", messageData)
    
            messageRef.current.value = ""
        }
    }

    function getMessages() {
        // socket.join(roomID)
        instance.post("/telemedicine/meeting/get_messages", {
            roomID: roomID
        })
        .then(response => {
            console.log(response.data);
            setMessages(response.data)
        })
        .catch(error => {
            console.log(error.response.data.message);
        })
    }

    socket.on("meeting_message_sent", data => {
        console.log("meeting_message_sent data is", data);
        messageNotif(true)
        setMessages(data.messages)
    })
   
    useEffect(() => {

        console.log("user is ", user);
        
        socket.emit("join_meeting_room", { roomID: roomID })
        getMessages()
    }, [isChatOpen])

    return (
        <>

        <div onClick={onChatClose} className={`${isChatOpen ? "block" : "hidden"} transition-all bg-[#11111180] fixed top-0 bottom-0 right-0 left-0` } />

        <div className={`${isChatOpen ? "right-0" : "right-[-100%] lg:right-[-400px]"} transition-all bg-[#20232b] z-[3000] flex flex-col fixed top-0 bottom-0 right-0 w-[100%] lg:w-[400px]`}>

           
            <div className="flex justify-between p-3 items-center">
                <div className="font-medium text-[14px] text-[#fafafa]">Chat</div>
                <button onClick={onChatClose}>
                    <X size={20} color="#fafafa" />    
                </button>
                
            </div>

            <div className="flex-1 flex flex-col p-3 space-y-6 overflow-y-scroll">
                {
                    messages.length < 1 ?
                    <div className="text-gray-500">No recent message</div> :
                    
                    messages?.map(item => {
                        // <div key={item.id}>{item.message}</div>
                        if (item.sender_name === `${user.prefix}. ${user.firstname} ${user.lastname}`) {
                            return (
                                <SenderBubbleV2 
                                    key={item.id}
                                    name={item.sender_name}
                                    message={item.message}
                                    time={formatTimestamp(item.created_at)}
                                />
                            )
                        } else {
                            return (
                                <SenderBubble 
                                    key={item.id}
                                    name={item.sender_name}
                                    message={item.message}
                                    time={formatTimestamp(item.created_at)}
                                />
                            )
                        }
                        
                    })
                }
            </div>
            
             
            <div className="flex items-center px-3 py-4 lg:p-3 gap-2">
                <input 
                    ref={messageRef} 
                    onChange={e => setMessage(e.target.value)} 
                    onKeyUp={(event) => {
                        if (event.key === "Enter") {
                            sendMessage()
                        }
                    }}
                    placeholder="Enter message" 
                    className="py-[10px] px-4 text-gray-200 text-[14px] bg-[#16181c] placeholder:text-[12px] placeholder:font-light placeholder:text-gray-600 outline-none rounded-full flex-1" />
                <button onClick={sendMessage} className="h-10 w-10 rounded-full bg-[#00b0ad] flex justify-center items-center">
                    <Send size={18} variant="Bold" color="#fff" />
                </button>
            </div>
    
           
        </div>
        </>
    )
}

export function ParticipantList({ isModalOpen, onModalClose, currentUser, participants }) {


    const [message, setMessage] = useState("")
    const socket = useContext(SocketContext)
    const [messages, setMessages] = useState([])
    const messageRef = useRef()

    const user = useLoaderData()


   

    useEffect(() => {

        console.log("user is ", participants);
    
        
    }, [isModalOpen])

    

    return (
        <>

        <div onClick={onModalClose} className={`${isModalOpen ? "block" : "hidden"} transition-all bg-[#11111180] fixed top-0 bottom-0 right-0 left-0` } />

        <div className={`${isModalOpen ? "right-0" : "right-[-100%] lg:right-[-400px]"} transition-all bg-[#20232b] z-[3000] flex flex-col fixed top-0 bottom-0 right-0 w-[100%] lg:w-[400px]`}>

           
            <div className="flex justify-between p-3 items-center">
                <div className="font-medium text-[14px] text-[#fafafa]">Meeting Participants ({participants.length + (currentUser ? 1 : 0)})</div>
                <button onClick={onModalClose}>
                    <X size={20} color="#fafafa" />    
                </button>
                
            </div>

            <div className="p-3">

                {
                    currentUser &&
                    <div className="flex justify-between py-3 items-center">
                        <div className="flex gap-2 items-center">
                            <div className="w-9 h-9 bg-[#16181c] uppercase rounded-full text-[12px] text-[#fafafa] flex justify-center items-center">
                                {currentUser[0]}{currentUser[currentUser.length - 1]}
                            </div>
                            <div className="text-[12px] text-[#fafafa]">{currentUser} (You)</div>
                        </div>

                        <MicrophoneSlash size={14} color="gray" variant="Bold"  />
                    </div>
                }
           

                {
                    participants.map(user => (
                        <div className="flex py-2 justify-between items-center">
                            <div className="flex gap-2 items-center">
                                <div className="w-9 h-9 bg-[#16181c] uppercase rounded-full text-[12px] text-[#fafafa] flex justify-center items-center">
                                    {user.uid[0]}{user.uid[user.uid.length - 1]}
                                </div>
                                <div className="text-[12px] text-[#fafafa]">{user.uid}</div>
                            </div>

                            <MicrophoneSlash size={14} color="gray" variant="Bold"  />
                        </div>
                    ))
                }
            </div>
    
           
        </div>
        </>
    )
}

export function SenderBubble({ name, message, time, key }) {
    return (
        <div className="flex flex-col items-start">
            <div className="flex items-center gap-3 mb-2">
                <div className="font-normal text-[10px] text-[#fafafa] capitalize">{name}</div>
                <div className="text-[10px] text-gray-500">{time}</div>
            </div>
        
            <div key={key} className="bg-[#16181c] max-w-[90%] text-[#f1f1f1] p-3 rounded-tl-[10px] rounded-r-[10px] relative">
                <div className="text-[12px] ">{message}</div>
            </div>
        </div>
    )
}

export function SenderBubbleV2({ name, message, time, key }) {
    return (
        <div className="flex flex-col items-end">
            <div className="flex items-center gap-3 mb-2">
                <div className="font-normal text-[10px] text-[#fafafa] capitalize">{name} (You)</div>
                <div className="text-[10px] text-gray-500">{time}</div>
            </div>
        
            <div key={key} className="bg-[#00b1ac] max-w-[90%] text-[#f1f1f1] p-3 rounded-tr-[10px] rounded-l-[10px] relative">
                <div className="text-[12px]">{message}</div>
            </div>
        </div>
    )
}

function LocalUserCameraOff() {
    return (
       
        <div className="bg-[#111] w-full h-full flex justify-center items-center">
            <div className="font-medium text-[14px] w-10 h-10 rounded-full bg-[#00b0ad] text-white flex justify-center items-center">Me</div>
        </div>
     
    )
}


export function meetingFormatDate() {
    const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
    return new Date().toLocaleDateString('en-US', options);
}

// Convert duration to HH:MM:SS
export const formatDuration = (seconds) => {
    const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${h}:${m}:${s}`;
};